import React from 'react';
import './CategoryPage.css';

const SearchResults = ({ searchResults, onSongClick }) => {
  if (searchResults.length === 0) return null;

  return (
    <div className="search-results">
      <h3 className="search-results-title">
        Search Results ({searchResults.length})
      </h3>
      <div className="search-results-grid">
        {searchResults.map((song, index) => (
          <div 
            key={song.id} 
            className="search-result-item"
            onClick={() => onSongClick(song)}
          >
            <div className="search-result-number">
              {song.songNumber}
            </div>
            <div className="search-result-main">
                <div className="search-result-title">
                  {song.title}
                  {song.englishTitle && (
                    <span className="english-title"> - {song.englishTitle}</span>
                  )}
                </div>
                {song.artist && (
                  <div className="search-result-artist">
                    {song.artist}
                  </div>
                )}
              </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SearchResults;
